export default __webpack_public_path__ + "static/media/bus_c2.3a493e43.svg";